module.exports = __webpack_public_path__ + "img/lab-room-partner.b1c830f2.png";